import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import ScreenReaderOnlyText from "../../../helpers/ScreenReaderOnlyText";
import Button from "../../../ui/CTA/Button";
import IconButton from "../../../ui/CTA/IconButton";
import { InfoIcon } from "../../../ui/Icon";
import BodyText from "../../../ui/Typography/texts/BodyText";
import PriorPriceModal from '../PriorPriceModal';
import styles from './PopUp.module.scss';
const PopUp = ({ popUpInfoText, popUpButtonLabelCancel, popUpButtonLabelLearnMore, popUpIconLabel, popUpPosition, modalHeaderPriorPrice, modalHeaderAboutLegislation, modalTextPriorPriceInfo, modalTextPriorPriceDescription, modalTextAboutLegislation, modalLink, modalLinkHref, modalButtonLabelCancel, onClickEvents, }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            setIsPopUpOpen(false);
        }
    };
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown, true);
    });
    const onIconButtonClick = () => {
        setIsPopUpOpen(true);
        setIsModalOpen(false);
        if (onClickEvents === null || onClickEvents === void 0 ? void 0 : onClickEvents.onPopUpOpen) {
            onClickEvents.onPopUpOpen();
        }
    };
    const onCancelButtonClick = () => {
        setIsPopUpOpen(false);
        if (onClickEvents === null || onClickEvents === void 0 ? void 0 : onClickEvents.onPopUpClosed) {
            onClickEvents.onPopUpClosed();
        }
    };
    const onLearnMoreButtonClick = () => {
        setIsModalOpen(true);
        setIsPopUpOpen(false);
        if (onClickEvents === null || onClickEvents === void 0 ? void 0 : onClickEvents.onModalOpen) {
            onClickEvents.onModalOpen();
        }
    };
    if (popUpInfoText && popUpButtonLabelCancel && popUpIconLabel) {
        return (React.createElement("div", { role: "tooltip", className: styles.tooltip },
            React.createElement(IconButton, { className: styles.IconButton, onClick: onIconButtonClick, iconElement: React.createElement(InfoIcon, { size: "small" }) }, popUpIconLabel),
            isPopUpOpen && (React.createElement("div", { className: classNames(styles.tooltipContent, popUpPosition === 'top' && styles.tooltipTop) },
                React.createElement(BodyText, { className: styles.text }, popUpInfoText),
                popUpButtonLabelLearnMore &&
                    modalHeaderPriorPrice &&
                    modalHeaderAboutLegislation &&
                    modalTextPriorPriceInfo &&
                    modalTextPriorPriceDescription &&
                    modalTextAboutLegislation &&
                    modalLink &&
                    modalLinkHref &&
                    modalButtonLabelCancel && (React.createElement(Button, { size: "small", primary: true, className: styles.button, fullWidth: true, onClick: onCancelButtonClick, role: "button" }, popUpButtonLabelCancel)),
                React.createElement(Button, { size: "small", secondary: true, fullWidth: true, onClick: onLearnMoreButtonClick, role: "button" }, popUpButtonLabelLearnMore))),
            isModalOpen && (React.createElement(PriorPriceModal, { isOpen: isModalOpen, onModalLinkOpen: onClickEvents === null || onClickEvents === void 0 ? void 0 : onClickEvents.onModalLinkOpen, onModalClosed: onClickEvents === null || onClickEvents === void 0 ? void 0 : onClickEvents.onModalClosed, modalHeaderPriorPrice: modalHeaderPriorPrice, modalTextPriorPriceInfo: modalTextPriorPriceInfo, modalTextPriorPriceDescription: modalTextPriorPriceDescription, modalHeaderAboutLegislation: modalHeaderAboutLegislation, modalTextAboutLegislation: modalTextAboutLegislation, modalLink: modalLink, modalLinkHref: modalLinkHref, modalButtonLabelCancel: modalButtonLabelCancel })),
            isPopUpOpen && (React.createElement("div", { className: styles.modalBackdrop, onClick: onCancelButtonClick, onKeyPress: onCancelButtonClick, role: "button", tabIndex: 0 },
                React.createElement(ScreenReaderOnlyText, null, popUpButtonLabelCancel)))));
    }
    return null;
};
export default PopUp;
//# sourceMappingURL=PopUp.js.map